interface EmptyCircleIconProps {
  className?: string;
  strokeWidth?: number;
}

/**
 * Hollow circle with a dash through it — the "not set" counterpart to
 * {@link CheckCircleIcon}. The dash keeps it legible at small sizes where a
 * bare outline reads as a rendering artefact.
 */
export const EmptyCircleIcon = ({
  className = 'h-3 w-3',
  strokeWidth = 1.5,
}: EmptyCircleIconProps) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="7.25" />
    <path d="M6.75 10h6.5" strokeLinecap="round" />
  </svg>
);
